import { render, staticRenderFns } from "./DownloadEntityComponent.vue?vue&type=template&id=772f0595&scoped=true&"
import script from "./DownloadEntityComponent.vue?vue&type=script&lang=js&"
export * from "./DownloadEntityComponent.vue?vue&type=script&lang=js&"
import style0 from "./DownloadEntityComponent.vue?vue&type=style&index=0&id=772f0595&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772f0595",
  null
  
)

export default component.exports